<template>
	<v-container fluid >
		<v-toolbar elevation="1">
			<v-app-bar-nav-icon :to="{ name: 'Dictionaries' }">
				<v-icon large :color="color">{{ icon }}</v-icon>
			</v-app-bar-nav-icon>
			<v-toolbar-title>
				<div class="text-h6">{{ title }}</div>
				<div class="text-subtitle-2 font-weight-light">{{ subtitle }}</div>
			</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<!-- <v-tabs-items v-model="tab">
			<v-tab-item> -->
				<v-card flat>
					<v-card-title>
						<!-- Nutrition -->
						<v-spacer></v-spacer>
						<v-text-field
							v-model="search.table.text"
							append-icon="mdi-magnify"
							label="Search"
							single-line
							hide-details
							@click:append="onSearch"
							@keyup.enter="onSearch"
						></v-text-field>
					</v-card-title>
					<v-card-title>
						<!-- <v-btn text v-for="letter in alphabet_en" :key="letter" :value="letter" class="ma-1"> -->
						<div>
							<v-btn text small v-for="letter in alphabet_en" :key="letter" :value="letter" @click="onFilterByLetter(letter)">{{ letter }}</v-btn>
						</div>
						<div>
							<v-btn text small v-for="letter in alphabet_uk" :key="letter" :value="letter" @click="onFilterByLetter(letter)">{{ letter }}</v-btn>
						</div>
						<!-- <v-btn-toggle v-model="selectedLetter" mandatory color="primary" variant="outlined">
							<v-btn text v-for="letter in alphabet_en" :key="letter" :value="letter" class="ma-1">
								{{ letter }}
							</v-btn>
						</v-btn-toggle> -->
					</v-card-title>
					<v-data-table
						:headers="headers"
						:items="items"
						:loading="loading.table"
						loading-text="Loading... Please wait"
					></v-data-table>
				</v-card>
			<!-- </v-tab-item>
		</v-tabs-items> -->
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
import zDetail from '@/views/dialogs/details/VehiclePark2'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete'

export default {
	name: 'DrugINN',
	//mixins: [mixin],
	components: {
		zVehicleParameters,
		downloadExcel,
		zDetail, zDialogEstimate,
		zConfirmDelete,
	},
	data: () => ({
		title: 'МНН',
		//subtitle: 'NFC (National Form Classification)',
		subtitle: 'Міжнародна непатентована назва лікарських засобів (МНН)',
		icon: 'mdi-pill-multiple',
		color: 'green darken-1',
		//loading: false,

		search: {
			table: {
				visible: false,
				text: '',
			},
		},

		loading: {
			table: false,
		},

		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			//{ text: 'Код', value: 'code', sortable: true},
			{ text: 'Назва', value: 'name', sortable: true},
			{ text: 'Назва англійською', value: 'nameEn', sortable: true},
			{ text: 'Опис', value: 'description', sortable: true},
			//{ text: 'Рівень', value: 'level', sortable: true},
			{ text: '', value: 'actions', sortable: false },
		],

		items: [],
	}),
	
	computed: {
		//...mapGetters('VehiclePark', [ 'items' ]),
		alphabet_en() {
			const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
			return alphabet
		},

		alphabet_uk() {
			const alphabet = "АБВГҐДЕЄЖЗІЇЙКЛМНОПРСТУФХЦЧШЩЮЯ".split("");
			return alphabet
		},
	},

	created () {
		//this.loadLevel1()
	},

	methods: {
		//...mapActions(['showMessage']),
		//...mapActions('VehiclePark', [ 'search', 'delete' ]),

		//--------------------------------------------------------------------

		onSearch() {
			//console.log(this.$options.name, 'loadModels','item1', item1)
			let that = this
			this.loading.table = true
			axios.get('/drug/inn', { params: { search: this.search.table.text }}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.table = false));
		},

		onFilterByLetter(letter){
			//console.log(this.$options.name, 'onFilterByLetter','letter', letter)
			let that = this
			this.loading.table = true
			axios.get('/drug/inn', { params: { letter: letter }}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.table = false));
		},
	},
}
</script>